import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ExportConfig } from '../../types';

interface DownloadActionPayload {
    values: ExportConfig;
    projectBranchName: null | string;
    projectId: string;
    isPreview?: boolean;
}

type InitialState = {
    loading: boolean;
    error: string | null;
};

const initialState: InitialState = {
    loading: false,
    error: null,
};

const slice = createSlice({
    name: 'downloadExport',
    initialState,
    reducers: {
        download: (state, action: PayloadAction<DownloadActionPayload>) => {
            state.loading = true;
            state.error = null;
        },
        generate: (state, action: PayloadAction<DownloadActionPayload>) => {
            state.loading = true;
            state.error = null;
        },
        downloadAfterGenerate: (state, action: PayloadAction<DownloadActionPayload>) => {
            state.error = null;
        },
        preview: (state, action: PayloadAction<DownloadActionPayload>) => {
            state.error = null;
        },
        loaded: (state) => {
            state.loading = false;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export default slice.reducer;

export const downloadExportActions = slice.actions;
